import { setHours, setMinutes, startOfDay } from "date-fns"
import { GlobalSettings } from "@/entities/globalSettings/globalSettings"

export type AttendanceTime =
   | "unknown"
   | "now"
   | "specific_time"
   | "start_of_day"
   | "morning_break"
   | "lunch_break"
   | "afternoon_break"
   | "end_of_day"

export const attendanceTimeTranslations: Record<AttendanceTime, string> = {
   unknown: "à déterminer",
   now: "Maintenant",
   specific_time: "Horaire précis",
   start_of_day: "Début de journée",
   morning_break: "Pause du matin",
   lunch_break: "Pause du midi",
   afternoon_break: "Pause de l'après-midi",
   end_of_day: "Fin de journée",
}

export const attendanceTimeToDate = (
   globalSettings: GlobalSettings,
   type: AttendanceTime,
   now: Date,
   inputTime?: string,
): Date => {
   switch (type) {
      case "now":
         return now
      case "specific_time": {
         if (!inputTime) throw new Error("inputTime required for specific_time");
         const [hours, minutes] = inputTime.split(":").map(Number);
         return setMinutes(setHours(now, hours), minutes);
      }
      case "start_of_day": {
         const [hours, minutes] = globalSettings.start_of_day.split(":").map(Number)
         return setMinutes(setHours(startOfDay(now), hours), minutes)
      }
      case "morning_break": {
         const [hours, minutes] = globalSettings.morning_break.split(":").map(Number)
         return setMinutes(setHours(startOfDay(now), hours), minutes)
      }
      case "lunch_break": {
         const [hours, minutes] = globalSettings.lunch_break.split(":").map(Number)
         return setMinutes(setHours(startOfDay(now), hours), minutes)
      }
      case "afternoon_break": {
         const [hours, minutes] = globalSettings.afternoon_break.split(":").map(Number)
         return setMinutes(setHours(startOfDay(now), hours), minutes)
      }
      case "end_of_day":
      case "unknown": {
         const [hours, minutes] = globalSettings.end_of_day.split(":").map(Number)
         return setMinutes(setHours(startOfDay(now), hours), minutes)
      }
      default:
         throw new Error("Invalid type")
   }
}
